
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, RouterOutlet } from '@angular/router';

import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpTokenInterceptor } from './core/interceptors';

import { routes } from './app.routes';
import { AppComponent } from './app.component';


@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule,
		RouterOutlet,
		RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
        }),
		HttpClientModule,
	],
	providers: [{provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true}],
	bootstrap: [AppComponent],
	exports: []
})
export class AppModule { }
